<template>
  <div v-if="ready" class="nav-icon-links">
    <div
      class="block"
      v-on:click="goToLink(icon)"
      v-for="icon in icons"
      :key="icon.link"
    >
      <div
        class="nav-icon-img"
        :class="{ 'nav-icon-img--circle-background': circleBackground }"
      >
        <img :src="icon.img" />
      </div>
      <div class="nav-title">{{ icon.title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navIconLinks',
  props: {
    icons: {
      type: Array,
      default: () => {
        return []
      },
    },
    circleBackground: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ready() {
      return this.icons != null && this.icons.length > 0
    },
  },
  methods: {
    goToLink(icon) {
      gtag('event', 'click', {
        event_id: '002',
        location: '首頁',
        event_category: '頻道按鈕',
        event_label: icon.title,
        value: 2,
      })
      this.$router.push({
        path: icon.link,
        query: {
          categoryNumber: icon.categoryNumber,
        },
      })
    },
  },
}
</script>

<style scoped lang="scss">
@mixin i5 {
  @media (max-width: 340px) {
    @content;
  }
}

.nav-icon-links {
  border-radius: 8px;
  margin: 8px 0;
  background-color: #f3f5f8;
  width: 100%;
  padding: 4px 6.4px 13px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  > .block {
    position: relative;
    flex: 0 0 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 13px;
    height: 76px;
    @include i5 {
      height: 85px;
    }

    > .nav-icon-img {
      overflow: hidden;
      width: 50px;
      height: 50px;
      margin-bottom: 6px;

      > img {
        width: 100%;
      }
    }

    > .nav-title {
      font-size: 12px;
      line-height: 14px;
      text-align: center;
      color: #4a4a4a;
    }

    > a {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
    }
  }

  .nav-icon-img--circle-background {
    display: flex;
    background: white;
    border-radius: 100px;
    justify-content: center;
    align-items: center;
    max-width: 50px;
    max-height: 50px;
    width: 50px;
    height: 50px;

    img {
      width: 42px !important;
      height: 42px;
    }
  }
}
</style>
